// src/components/nav-main.tsx
import {
    SidebarGroup,
    SidebarMenu,
    SidebarMenuItem,
    SidebarMenuButton,
} from "@/components/ui/sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export interface NavMainItem {
    title: string;
    icon: React.ReactNode;
    href: string;
    description?: string;
}

export function NavMain({
    items,
}: {
    items: NavMainItem[];
}) {
    const location = useLocation();
    const navigate = useNavigate();
    const [activePath, setActivePath] = useState<string>(location.pathname);

    useEffect(() => {
        setActivePath(location.pathname);
    }, [location.pathname]);

    const handleNavigation = (itemUrl: string, event: React.MouseEvent) => {
        event.preventDefault();
        const fullUrl = `/dashboard/${itemUrl}`;
        
        // If we're already in this section (e.g., /dashboard/workflows/something)
        // and clicking the same section link (e.g., /dashboard/workflows)
        if (location.pathname.startsWith(fullUrl) && location.pathname !== fullUrl) {
            // Navigate directly to the root URL without the temporary route
            navigate(fullUrl, { replace: true });
        } else {
            navigate(fullUrl);
        }
    };

    return (
        <SidebarGroup>
            <SidebarMenu>
                {items.map((item) => {
                    const fullPath = `/dashboard/${item.href}`;
                    const isActive = activePath.startsWith(fullPath);

                    return (
                        <SidebarMenuItem key={item.href}>
                            <SidebarMenuButton
                                asChild
                                data-active={isActive}
                                className={isActive ? 'active' : ''}
                                tooltip={item.title}
                            >
                                <Link
                                    to={fullPath}
                                    onClick={(e) => handleNavigation(item.href, e)}
                                    className="flex items-center"
                                >
                                    {item.icon}
                                    <span>{item.title}</span>
                                </Link>
                            </SidebarMenuButton>
                        </SidebarMenuItem>
                    );
                })}
            </SidebarMenu>
        </SidebarGroup>
    );
}
